// hooks/useAMIBreakdown.js
import { useQuery } from '@tanstack/react-query';
import { reactQueryFinanceDefaults } from './queryDefaults';
import apiService from '../../services/api';
import { ENDPOINTS } from '../../services/endpoints';

const useAMIBreakdown = (dateRange) => {
  const fetchAMIData = async () => {
    const response = await apiService.get(ENDPOINTS.FINANCE_AMI_BREAKDOWN, {
      start_date: dateRange.start_date,
      end_date: dateRange.end_date
    });
        
    if (!response) {
      throw new Error("No AMI data returned from API");
    }
    
    const apiData = response.data || response;
        
    if (!apiData.monthly_breakdown || apiData.monthly_breakdown.length === 0) {
      console.warn('No monthly breakdown data in response');
    }
    
    return {
      goals: apiData.goals || { labor_costs: 55, overhead: 25, profit: 20 },
      period_averages: apiData.overall_metrics || {},
      monthly_breakdown: apiData.monthly_breakdown || [],
      period: apiData.period || {},
      lastUpdated: new Date().toISOString(),
    };
  };

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ['amiBreakdown', dateRange?.start_date, dateRange?.end_date], // ✅ ADD dateRange to queryKey
    queryFn: fetchAMIData,
    enabled: !!dateRange?.start_date && !!dateRange?.end_date, // ✅ Only run if we have valid dates
    ...reactQueryFinanceDefaults,
  });

  return {
    goals: data?.goals || { labor_costs: 55, overhead: 25, profit: 20 },
    period_averages: data?.period_averages || {},
    monthly_breakdown: data?.monthly_breakdown || [],
    period: data?.period || {},
    lastUpdated: data?.lastUpdated || null,
    
    loading: isLoading,
    refreshing: isFetching,
    
    error: isError ? (error?.message || 'Failed to load AMI data') : null,
    isError,
    
    initialized: !!data,
    
    refetch,
  };
};

export { useAMIBreakdown };